import { setEndTime } from '../../search-and-filter-schema/protected';
const updateEndTime = (filters, value) => {
  return setEndTime(value, filters);
};
export default updateEndTime;